import { useState } from "react";
import { api } from "../lib/api";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import RoofMap from "./RoofMap";
import { LayoutGrid, Pencil } from "lucide-react";

const n = (v) => Number(v || 0).toLocaleString("it-IT", { maximumFractionDigits: 2 });

// Pannelli fissati dal layout sviluppato: modificabili solo cambiando il layout.
export function LayoutLockBox({ ll, lead, onUpdate, canEdit }) {
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState(lead);
  const limited = Number(ll.fabbisogno_kwp || 0) > Number(ll.kwp || 0);
  const close = async (v) => {
    setOpen(v);
    if (!v) {
      try { const { data } = await api.get(`/leads/${lead.id}`); onUpdate(data); } catch { /* resta il dato corrente */ }
    }
  };
  return (
    <div className="rounded border border-primary/40 bg-primary/10 p-3 flex flex-wrap items-start justify-between gap-3" data-testid="layout-lock-box">
      <div className="flex items-start gap-2 text-xs">
        <LayoutGrid className="h-4 w-4 text-primary mt-0.5 shrink-0" />
        <div>
          <div className="font-semibold text-sm text-primary" data-testid="layout-lock-title">Limitato dal layout: {ll.count} moduli · {n(ll.kwp)} kWp</div>
          <p className="text-muted-foreground mt-0.5">
            {limited ? <>Fabbisogno dai consumi {n(ll.fabbisogno_kwp)} kWp. </> : null}
            Il numero di pannelli segue il layout sviluppato e l'accumulo viene ricalcolato sulla nuova potenza. Per cambiarlo modifica il layout.
          </p>
        </div>
      </div>
      {canEdit && (
        <Button size="sm" variant="outline" className="gap-1.5 shrink-0" onClick={() => { setDraft(lead); setOpen(true); }} data-testid="layout-lock-edit-btn">
          <Pencil className="h-3.5 w-3.5" /> Modifica layout
        </Button>
      )}
      <Dialog open={open} onOpenChange={close}>
        <DialogContent className="max-w-6xl max-h-[92vh] overflow-y-auto" data-testid="layout-edit-dialog">
          <DialogHeader><DialogTitle>Modifica layout del tetto</DialogTitle></DialogHeader>
          <p className="text-xs text-muted-foreground -mt-2">Alla chiusura il preventivo si aggiorna con i moduli del layout.</p>
          {open && <RoofMap lead={draft} onUpdate={setDraft} rete={lead.channel === "rete" && !lead.rete_unlocked} />}
        </DialogContent>
      </Dialog>
    </div>
  );
}
